import { useState } from 'react';
import { Dropdown as BSDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import classNames from 'classnames';

import { UserAvatar } from '@preqin/ui-components/cjs/icons/user';

import styles from './Dropdown.module.scss';

export type DropDownProps = {
  toggleComponent?: React.ReactNode;
  toggleIcon?: React.ComponentClass;
  toggleIconSize?: 'small' | 'medium';
  menuItems: React.ReactNode;
  dropdownMenuProps?: Object; // Used to pass all the props for reactstrap DropdownItem component
};

export const Dropdown = ({
  toggleComponent,
  toggleIcon,
  toggleIconSize,
  menuItems,
  dropdownMenuProps,
}: DropDownProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const ToggleIcon = toggleIcon || UserAvatar;

  return (
    <BSDropdown cssModule={styles} className={classNames({ open: dropdownOpen })} isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle cssModule={styles} color="default">
        <div className={classNames(styles.wrapper, styles.noEvents)}>
          {toggleComponent}
          <ToggleIcon className={classNames(styles.icon, { [styles.medium]: toggleIconSize === 'medium' })} />
        </div>
      </DropdownToggle>
      <DropdownMenu cssModule={styles} {...dropdownMenuProps}>
        <div className={styles.menu}>
          <div className={styles.menuItems}>{menuItems}</div>
        </div>
      </DropdownMenu>
    </BSDropdown>
  );
};
